import ReactGA from 'react-ga';

ReactGA.initialize('UA-145640712-1', {
    debug: false,
});

/*const excludedActions = [
    'assetCoreData',
    'assetSensorData',
    'socketNewEvent',
];*/

const analyticsMiddleware = () => {
    return store => next => action => {
        if (action.type === 'layout/setCurrentPage') {
            const nextPage = `${action.payload}`;
            trackPage(nextPage);
        } else {
            trackEvent(action);
        }
        return next(action);
    }
}


export default analyticsMiddleware;

const trackEvent = (action) => {
    if (action.type === 'user/loginUser/fulfilled') {
        //console.log("setting userid", action.payload.username);
        ReactGA.set({ userId: action.payload.username });
    }

    const actiondets = action.type.split('/');
    let category, actiontype;
    if (actiondets.length === 1) {
        category = 'app';
        actiontype = actiondets[0];
    } else {
        category = actiondets[0];
        actiontype = actiondets[1];
    }
    if (includedActions().indexOf(actiontype) !== -1) {
        ReactGA.event({ category, action: actiontype }); // Track event to google analytics
    }
};




function trackPage(page) {
    //console.log("Track page", page);
    ReactGA.set({
        page
    });
    ReactGA.pageview(page);
};

function includedActions() {
    return [
        //login section
        ...loginActions(),

        //liveTracking
        ...liveTrackingAction(),

        //map
        ...mapActions(),

        //Tracks
        ...trakcActions(),

        //Events
        ...eventActions(),

        //Places
        ...placesActions(),

        //Reports
        ...reportActions(),
    ];
}

function loginActions() {
    return [
        'loginUser',
        'searchUsername',
        'searchUserbyAsset',
        'getUserAccess',
        'addOwnGoogleKey',
        'adhocCredit',
    ];
}

function liveTrackingAction() {
    return [
        "setDetailView",
        "removeDetailView",
        "addToPinnedAsset",
        "removeFromPinnedAsset",
        "unpinAllAssets",
        "showAllAssets",
        "clearVisibleAssetsMarkers",
        "restoreVisibleAssetsMarkers",
        "addToVisbleAssetsMarkers",
        "removeFromVisibleAssetsMarkers",
        "searchAssetName",
        "statusFilter",
        "summaryFilter",
        "resetShareLink",
        "setViewType",
        "firstLoad",
        "getKilometersOneAsset",
        "changeOdometer",
        "changeIcon",
        "shareLink",
        "lockUnlock",
    ]
}

function mapActions() {
    return [
        "changeMapService",
        "zoomIn",
        "zoomOut",
        "changeGoogleMapTypeId",
    ];
}

function trakcActions() {
    return [
        "socketTrackBuilt",
        "addToVisisbleTracks",
        "removefromVisibleTracks",
        "removeAllFromVisibleTracks",
        "setTrackDetailView",
        "setTimeLineView",
        "setbottomView",
        "setHighlightedDrive",
        "removeHighlightedDrive",
        "setHighlightedStop",
        "removeHighlightedStop",
        "setHighlightedEvent",
        "removeHighlightedEvent",
        "addToPinnedTracks",
        "removefromPinnedTracks",
        "setTrackPlayerIndex",
    ];
}

function eventActions() {
    return [
        "setViewType",
        "setEventDetailView",
        "removeEventDetailView",
        "setSelectedAssetId",
        "removeSelectedAssetId",
        "toggleEventTicker",
        "incrementEventPageIndex",
        "decrementEventPageIndex",
        "setEventsPerPage",
        "searchEventAssetId",
        "searchEventsMulti",
        "defaultEventsLoad",
    ];
}

function placesActions() {
    return [
        "addToPinnedMarker",
        "removeFromPinnedMarker",
        "addToPinnedZone",
        "removeFromPinnedZone",
        "unpinAllMarkers",
        "unpinAllZones",
        "addTovisibleMarkersList",
        "removeFromvisibleMarkersList",
        "addTovisibleZonesList",
        "removeFromvisibleZonesList",
        "addToVisibleMarkersMap",
        "removeFromVisibleMarkersMap",
        "addToVisibleZonesMap",
        "removeFromVisibleZonesMap",
        "clearVisibleMarkersMap",
        "clearVisibleZonesMap",
        "restoreVisibleMarkersMap",
        "restoreVisibleZonesMap",
        "searchZones",
        "searchMarkers",
        "setZoneDetailView",
        "removeZoneDetailView",
        "setMarkerDetailView",
        "removeMarkerDetailView",
        "toggleZoneDrafting",
        "addZoneDraftCoords",
        "removeZoneDraftCoords",
        "relocateZoneDraftCoords",
        "updateZoneDraftColor",
        "clearZoneDraftCoords",
        "editZone",
        "toggleMarkerDrafting",
        "addMarkerDraftCoords",
        "removeMarkerDraftCoords",
        "relocateMarkerDraftCoords",
        "updateMarkerDraftColor",
        "clearMarkerDraftCoords",
        "editMarker",
        "setItemsPerPage",
        "incrementZonePageIndex",
        "decrementZonePageIndex",
        "incrementMarkerPageIndex",
        "decrementMarkerPageIndex",
    ];
}

function reportActions() {
    return [
        "getReportList",
        "downloadReport",
        "deleteReport",
        "reportTtl",
        "getPdf",
        "emailPdf",
        "buildReportMulti",
        "buildReportOne",
    ];
}